var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97861 0L0.0426636 9.73665L5.97861 7.13167L12 9.73665L5.97861 0Z",
    fill: "#7759F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97865 7.04639L0 9.73678L5.97865 13.1531L12 9.73678L5.97865 7.04639Z",
    fill: "url(#paint0_linear_75_92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97872 19.0889L0.0854797 10.8896L5.97872 14.306L11.9147 10.8896L5.97872 19.0889Z",
    fill: "#7759F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_92",
    x1: 6,
    y1: 7.04639,
    x2: 6,
    y2: 13.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D30CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7759F3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon-diamond.6619b2d679bc40f9bcecd3598adcb9d4.svg";
export { ForwardRef as ReactComponent };